document.addEventListener('DOMContentLoaded', function () {
    const headerLogoScrollToTop = document.getElementById('header-logo-icon');

    if (headerLogoScrollToTop) {
        headerLogoScrollToTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    // Add scroll to parameters button functionality
    const scrollToParametersButton = document.querySelector('.scroll-to-subscription');

    if (scrollToParametersButton) {
        scrollToParametersButton.addEventListener('click', function () {
            const parametersSection = document.querySelector('.main-cart-button');

            if (parametersSection) {
                parametersSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        });
    }

    let productFormButtons = document.querySelector('.main-cart-button');

    if (!productFormButtons) {
        productFormButtons = document.querySelector('button');
    }

    const topSection = document.getElementById('top-section');

    function handleScroll() {
        const buttonTop = productFormButtons.getBoundingClientRect().top;

        topSection.style.display = buttonTop < 0 ? 'block' : 'none';
    }

    window.addEventListener('scroll', handleScroll);

    handleScroll();


});